<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="员工姓名" prop="employeeName">
        <el-input
          v-model="queryParams.employeeName"
          class="!w-240px"
          clearable
          placeholder="请输入员工姓名"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="提成类型" prop="commissionType">
        <el-select
          v-model="queryParams.commissionType"
          class="!w-240px"
          clearable
          placeholder="请选择提成类型"
        >
          <el-option label="销售提成" value="SALES" />
          <el-option label="清洁提成" value="CLEANING" />
          <el-option label="维修提成" value="MAINTENANCE" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          v-model="queryParams.status"
          class="!w-240px"
          clearable
          placeholder="请选择状态"
        >
          <el-option label="待审核" value="PENDING" />
          <el-option label="已审核" value="APPROVED" />
          <el-option label="已发放" value="PAID" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:commission-record:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="员工姓名" prop="employeeName" min-width="100" />
      <el-table-column align="center" label="提成类型" prop="commissionType" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.commissionType === 'SALES'" type="primary">销售提成</el-tag>
          <el-tag v-else-if="scope.row.commissionType === 'CLEANING'" type="success">清洁提成</el-tag>
          <el-tag v-else-if="scope.row.commissionType === 'MAINTENANCE'" type="warning">维修提成</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="来源类型" prop="sourceType" min-width="120">
        <template #default="scope">
          <el-tag v-if="scope.row.sourceType === 'ORDER'" type="primary">订单</el-tag>
          <el-tag v-else-if="scope.row.sourceType === 'CLEANING_TASK'" type="success">清洁任务</el-tag>
          <el-tag v-else-if="scope.row.sourceType === 'MAINTENANCE_ORDER'" type="warning">维修工单</el-tag>
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="来源ID" prop="sourceId" min-width="120" />
      <el-table-column align="center" label="提成金额" prop="amount" min-width="100">
        <template #default="scope">
          <span style="color: #f56c6c; font-weight: bold;">
            {{ scope.row.amount != null ? '￥' + scope.row.amount : '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="单价" prop="unitPrice" min-width="100">
        <template #default="scope">
          {{ scope.row.unitPrice != null ? '￥' + scope.row.unitPrice : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="数量" prop="quantity" min-width="80" />
      <el-table-column align="center" label="周期" prop="period" min-width="100" />
      <el-table-column align="center" label="状态" prop="status" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.status === 'PENDING'" type="info">待审核</el-tag>
          <el-tag v-else-if="scope.row.status === 'APPROVED'" type="primary">已审核</el-tag>
          <el-tag v-else-if="scope.row.status === 'PAID'" type="success">已发放</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="150" fixed="right">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:commission-record:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['hotel:commission-record:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select v-model="formData.shopId" placeholder="请选择店铺" filterable clearable>
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="员工" prop="employeeId">
        <el-select v-model="formData.employeeId" placeholder="请选择员工" filterable>
          <el-option v-for="item in employeeList" :key="item.id" :label="item.name + ' (' + item.employeeNo + ')'" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="提成类型" prop="commissionType">
        <el-radio-group v-model="formData.commissionType">
          <el-radio value="SALES">销售提成</el-radio>
          <el-radio value="CLEANING">清洁提成</el-radio>
          <el-radio value="MAINTENANCE">维修提成</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="来源类型" prop="sourceType">
        <el-radio-group v-model="formData.sourceType">
          <el-radio value="ORDER">订单</el-radio>
          <el-radio value="CLEANING_TASK">清洁任务</el-radio>
          <el-radio value="MAINTENANCE_ORDER">维修工单</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="来源ID" prop="sourceId">
        <el-input v-model="formData.sourceId" placeholder="请输入来源ID" />
      </el-form-item>
      <el-form-item label="提成金额" prop="amount">
        <el-input-number
          v-model="formData.amount"
          :min="0"
          :precision="2"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="单价" prop="unitPrice">
        <el-input-number
          v-model="formData.unitPrice"
          :min="0"
          :precision="2"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="数量" prop="quantity">
        <el-input-number
          v-model="formData.quantity"
          :min="0"
          :precision="0"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="周期" prop="period">
        <el-input v-model="formData.period" placeholder="如 2026-07" />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio value="PENDING">待审核</el-radio>
          <el-radio value="APPROVED">已审核</el-radio>
          <el-radio value="PAID">已发放</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import * as CommissionRecordApi from '@/api/hotel/commissionRecord'
import { getEmployeeListAll } from '@/api/hotel/employee'
import { getShopSimpleList } from '@/api/hotel/platformShop'

defineOptions({ name: 'HotelCommissionRecord' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

// 店铺下拉列表
const shopList = ref<any[]>([])
const getShopList = async () => {
  const data = await getShopSimpleList()
  shopList.value = data || []
}

// 员工下拉列表
const employeeList = ref<any[]>([])
const getEmployeeList = async () => {
  const data = await getEmployeeListAll()
  employeeList.value = data || []
}

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  employeeName: undefined,
  commissionType: undefined,
  status: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await CommissionRecordApi.getCommissionRecordPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<CommissionRecordApi.CommissionRecordVO>({
  id: undefined,
  shopId: undefined,
  employeeId: undefined,
  commissionType: 'SALES',
  sourceType: 'ORDER',
  sourceId: undefined,
  amount: 0,
  unitPrice: undefined,
  quantity: undefined,
  period: '',
  status: 'PENDING',
  createTime: undefined as any
})
const formRules = reactive({
  employeeId: [{ required: true, message: '员工不能为空', trigger: 'blur' }],
  commissionType: [{ required: true, message: '提成类型不能为空', trigger: 'change' }],
  sourceType: [{ required: true, message: '来源类型不能为空', trigger: 'change' }],
  sourceId: [{ required: true, message: '来源ID不能为空', trigger: 'blur' }],
  amount: [{ required: true, message: '提成金额不能为空', trigger: 'blur' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await CommissionRecordApi.getCommissionRecord(id)
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = formData.value
    if (formType.value === 'create') {
      await CommissionRecordApi.createCommissionRecord(data)
      message.success(t('common.createSuccess'))
    } else {
      await CommissionRecordApi.updateCommissionRecord(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    shopId: undefined,
    employeeId: undefined,
    commissionType: 'SALES',
    sourceType: 'ORDER',
    sourceId: undefined,
    amount: 0,
    unitPrice: undefined,
    quantity: undefined,
    period: '',
    status: 'PENDING',
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await CommissionRecordApi.deleteCommissionRecord(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

onMounted(() => {
  getList()
  getEmployeeList()
  getShopList()
})
</script>
